import { conversionRateBus } from "@/event/conversionRateBus"
import { productBus } from "@/event/product/productBus"
import { quantityBus } from "@/event/product/quantityBus"
import { selectOptionsListHappy } from "@/happyTheme/event/product/selectOptionsListHappy"

export function getTotalPriceHappy() {
    let totalPrice = 0

    if (productBus.value) {
        totalPrice = totalPrice + Number(convertFinalPrice())
    }
    return totalPrice
}

function convertFinalPrice() {
    const priceProduct = Number(productBus.value?.price)
    let priceConvertedQuantity = priceProduct
        * conversionRateBus.value
        * quantityBus.value

    if (selectOptionsListHappy.value) {
        Object.values(selectOptionsListHappy.value).forEach((solh) => {
            if (solh.selected_values.radio_option.option_value_id !== 0) {
                priceConvertedQuantity = priceConvertedQuantity + Number(solh.selected_values.radio_option.option_value_price) * conversionRateBus.value
                    * quantityBus.value
            } else if (solh.selected_values.checkbox_option.option_value_paid.length !== 0) {
                solh.selected_values.checkbox_option.option_value_paid.forEach((ovp) => {
                    priceConvertedQuantity = priceConvertedQuantity + Number(ovp.option_value_price) * conversionRateBus.value
                        * quantityBus.value
                })
            }
        })
    }

    return priceConvertedQuantity
}